import { Lock } from "lucide-react";

export default function PremiumFeatureBadge() {
  return (
    <Lock className="size-3 text-[#ffa732] group-hover:rotate-90 duration-500 transition-all" />
  );
}
